// The league mock, together (MOCK_DRAFT.md §6.2): the one open in a league,
// and opening one. The room itself is the socket (`useLiveDraft` with the
// mock's id).

import { LeagueMockSummary, LeagueMockView } from '@fsp/domain';
import { get, send, type Reply } from './api';
import { thenRefresh, useMovesVersion } from './moves';
import { useRead, type Read } from './read';

const path = (leagueId: string) => `/leagues/${encodeURIComponent(leagueId)}/draft/together`;

/** The league mock open now in a league, or `open: null`. */
export function useLeagueMock(leagueId: string | null): Read<LeagueMockView | null> {
  return useRead(leagueId === null ? null : path(leagueId), LeagueMockView, {
    refresh: useMovesVersion(leagueId),
  });
}

/**
 * Whether this mock is the one open now. Unsure — no answer, or a refusal —
 * reads as open, so a page on a bad connection keeps trying.
 */
export async function mockStillOpen(leagueId: string, mockId: string): Promise<boolean> {
  const reply = await get(path(leagueId), LeagueMockView);
  return reply.status !== 'ok' || reply.data.open?.id === mockId;
}

/** Open one with this clock, or join the one already open whatever its clock. */
export function openLeagueMock(
  leagueId: string,
  pickSeconds: 30 | 60 | 90,
): Promise<Reply<LeagueMockSummary>> {
  return thenRefresh(leagueId, send('POST', path(leagueId), { pickSeconds }, LeagueMockSummary));
}
